import { functions } from '../firebaseConfig'

export default {
  namespaced: true,

  // module assets
  state: {
    sessionId: null
  },
  getters: {
    sessionId: state => state.sessionId
  },
  actions: {
    async createSessionId ({ commit }) {
      const { data: { sessionId } } = await functions.httpsCallable('pagseguro/sessionId')()
      commit('setSessionId', sessionId)
    }
  },
  mutations: {
    setSessionId: (state, sessionId) => {
      state.sessionId = sessionId
    }
  }
}
